<template>
    <div class="my-1">
        <b-card>
            <div class="row">
                <div class="form-group col-5">
                    <b-input-group size="sm">
                        <b-input-group-prepend is-text>
                            <b-link @click="buscar"><b-icon icon="search"></b-icon></b-link>
                        </b-input-group-prepend>
                        <b-form-input v-model="txt"
                            required trim v-uppercase
                            @keydown.enter.native="buscar"
                        >
                        </b-form-input>
                    </b-input-group>
                    <label class="text-small">Busqueda x Expediente ó DNI Clientes</label>
                </div>
                <!-- <b-icon variant="success" icon="cart3"></b-icon> -->
                <div class="form-group col-7">
                    <!-- <label>EXPEDIENTE</label><br> -->
                </div>
            </div>
            <!-- Grid Datos -->
            <!-- <b-table striped hover sticky-header="440px" head-variant="light"
                :items="exped.items" :fields="exped.fields"
                class="table-responsive-md bg-white" responsive="sm">

                <template slot="cell(n1)" slot-scope="{item: { n1 }}">
                    {{ n1 }}<small>{{ n2 }}</small>
                </template>
            </b-table> -->
            <b-card>
                <div class="row" v-if="exp.id>0">
                    <div class="col-2">
                        <span class="small">Expediente</span>
                        <p><b>{{ exp.id }}</b></p>
                    </div>
                    <div class="col-3">
                        <span class="small">Cliente/s</span>
                        <p><b>{{ exp.d1 }}<br>{{ exp.d2 }}<br>{{ exp.d3 }}</b></p>
                    </div>
                    <div class="col-7"><span class="small">Nombre/s</span>
                        <p><b>{{ exp.n1 }}<br>{{ exp.n2 }}<br>{{ exp.n3 }}</b></p>
                    </div>
                    <hr>
                <!-- </div>
                <div class="row"> -->
                    <div class="col-2"><span class="small">Telefono/s</span>
                        <p><strong>{{ exp.tfn1 }}<br>{{ exp.tfn2 }}</strong></p>
                    </div>
                    <div class="col-10"><span class="small">Población</span>
                        <p><strong>{{ exp.pob }} ( {{ exp.pro }} )</strong></p>
                    </div>

                </div>

                <div class="text-center" v-else>
                    Introduce Identificador de Expediente o DNI del cliente para realizar la Busqueda

                    <b-btn size="xs" variant="outline-primary" class="mt-2 p-1" @click="cancela">
                        <small><b-icon icon="x-circle"></b-icon> Inicializar Datos Expediente en Reserva</small>
                    </b-btn>
                </div>
            </b-card>
        </b-card>

        <!-- Opciones -->
        <div class="row mx-1  mt-1 bg- text-faded">
            <div v-if="exp.id>0 && exp.loc>0" class="w-100 text-center bg-danger text-white p-3">
                IMPOSIBLE SELECCION<br>YA TIENE RESERVA LOCALIZADOR <b>{{ exp.loc }}</b>

            </div>
            <div v-if="exp.loc==0" class="w-100 text-center bg-secondary p-3">
                <b-btn size="lg" class="bg-secondary p-2 w-100" @click="selecciona">
                    <b-icon variant="success" icon="cart3"></b-icon> Seleccionar
                </b-btn>
        </div>

            <!-- <div class="col-6">Periodos <b>{{turnosFiltrados.length}}</b></div> -->
            <!-- <div class="col-6 pr-5 mt-1">
                <b-icon variant="success" icon="cart3"></b-icon> Seleccionar
                <b-icon variant="danger" icon="x-square" class="ml-4"></b-icon> Sin disponibilidad
            </div> -->
        </div>
    </div>
</template>

<script>

import { mapState, mapMutations, mapActions } from 'vuex'; //store

export default {
    name: 'buscaExped',

    data() {
        return {
            txt: '',

        }
    },

    mounted() {
        this.exped.items=[];

    },

    computed: {
        ...mapState(['auth','exped']),

        exp() {
            return this.exped.items[0] || {};
        },
        busca() {
            return this.exped.busca || 1;
        },
        reserva() {
            return this.$store.state.reserva;
        },

        /* exped() {
            return this.$store.state.exped;
        }, */

    },
    methods: {
        ...mapMutations(['loading','alerta','modal']),
        ...mapActions(['exec','error']),

        async buscar() {
            console.log("*busca_exped",this.exp);

            //this.loading();
            var arg={ token: this.auth.token, txt: this.txt };
            let r=await this.exec({api:'exped', arg});

            let data=r.r;
            if (await this.error({r, tit:'EXPED'})) data=[];
            //this.$store.commit('hoteles_back', data);
            this.exped.items=this.$util.object_array(data);
            // Montamos boton selecciona o si ha viajado
            console.log("*busca_exped2",this.exped.items);

            //this.loading(false);
        },

        selecciona(evt) {
            //datos reserva
            console.log('**busca_exped-selecciona',this.$route.name,evt,this.exp)
            let R=this.reserva;

            if  (this.busca==3) {
                if (R.exp==this.exp.id || R.exp2==this.exp.id) {
                    this.modal({ tit: this.modulo, msg: 'No se puede seleccionar el mismo expediente', time: 0 });
                    return;
                }
                if (this.exp.d2) {
                    this.modal({ tit: this.modulo, msg: 'No se puede seleccionar expediente con 2 personas', time: 0 });
                    return;
                }
                R.exp3=this.exp.id;
                R.d3=this.exp.d1; R.n3=this.exp.n1;
                //R.d3=this.exp.d2; R.n3=this.exp.n2;
                //R.d4=this.exp.d3; R.n4=this.exp.n3;
                if (!this.exp.tfn2) R.tf2=this.exp.tfn1;
                R.pax+=(this.exp.d3>''?3:(this.exp.d2>''?2:1));
                R.ind=0;

            } else
            if  (this.busca==2) {
                if (R.exp==this.exp.id) {
                    this.modal({ tit: this.modulo, msg: 'No se puede seleccionar el mismo expediente', time: 0 });
                    return;
                }
                R.exp2=this.exp.id;
                R.d2=this.exp.d1; R.n2=this.exp.n1;
                R.d3=this.exp.d2; R.n3=this.exp.n2;
                R.d4=this.exp.d3; R.n4=this.exp.n3;
                if (this.exp.tfn1>'') R.tf2=this.exp.tfn1;
                R.pax+=(this.exp.d3>''?3:(this.exp.d2>''?2:1));
                R.ind=0;

            } else {
                R.exp=this.exp.id;
                R.exp2=R.exp3='';
                this.reserva.d1=this.exp.d1; this.reserva.n1=this.exp.n1;
                this.reserva.d2=this.exp.d2; this.reserva.n2=this.exp.n2;
                this.reserva.d3=this.exp.d3; this.reserva.n3=this.exp.n3;
                this.reserva.d4=this.exp.d4; this.reserva.n4=this.exp.n4;
                this.reserva.pob=this.exp.pob; this.reserva.pro=this.exp.pro;
                this.reserva.tf1=this.exp.tfn1;
                this.reserva.tf2=this.exp.tfn2;
                this.reserva.pax=(this.exp.d3>''?3:(this.exp.d2>''?2:1));
                this.reserva.ind=(this.reserva.pax==1?1:0);
                //tph,tpp ...
            }


            if (this.$route.name!='reserva') this.$router.push('/reserva');
            this.close();
        },

        cancela(evt) {
            console.log('**busca_exped-cancela',this.$route.name,evt,this.exp)
            let R=this.reserva;

            if (this.busca==2) {
                if (R.exp3) {
                    R.exp2=R.exp3;
                    R.d2=R.d3; R.n2=R.n3;
                    R.exp3=R.d3=R.n3='';
                    R.pax=2;
                } else {
                    R.exp2='';
                    R.d2=R.n2='';
                    R.pax=1;
                }
            } else
            if (this.busca==3) {
                R.exp3=R.d3=R.n3='';
                R.pax=2;
            } else {
                R.exp=R.exp2=R.exp3='';
                R.d1=R.n1=R.d2=R.n2=R.d3=R.n3='';
                R.pob=R.pro=R.tf1=R.tf2='';
                R.pax=R.ind=0;
            }

            if (this.$route.name!='reserva') this.$router.push('/reserva');
            this.close();
        },


        close() {
            this.$bvModal.hide('modal_buscaExped');
        }
    }
}
</script>
